export function sizeToMb(file) {
    if(file.size){
        return (Math.round(parseInt(file.size * 0.0001))/100) + 'mb';
    }
    return '';
}